import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    addPopup,
    addMagainzeCrumb,
    getArticlesByCategory,
    getVideoArticleById,
    getVideoArticles,
} from '../../../../redux/actions';
import { AnalyticsParamValues } from '../../../../constants/analytics';
import * as popups from '../../../../constants/popup-types';
import * as routes from '../../../../constants/routes';
import ArticlesStrip from '../../../magazine/components/ArticlesStrip';
import './index.scss';
import { useGetArticlesByCategoryQuery, useGetVideoArticlesCategoryByPageNumberQuery } from '../../../../redux/api/content.api';

let observer = null;
let isApiRequestInProgress = false;


const MagazineGeneric = ({category}) => {
    const loadMoreRef = useRef();
    const [pageNumber, setPageNumber] = useState(0);
    // const [requestFlag, setRequestFlag] = useState(false);
    const [articles, setArticles] = useState();
    const [endOfArticles, setEndOfArticles] = useState(false);
    const texts = useSelector(store => store.config.Translations)
    const dispatch = useDispatch();

    const handleType = (category) => {
        if(category !== texts['magazine_video_category']){
            return 'text';
        }
        return 'video';
    }
    
    let data, isSuccess;

    const fetchType = handleType(category);

    if(fetchType === 'text'){
        ({ data, isSuccess } = useGetArticlesByCategoryQuery({ categoryId: category.id, pageNumber: pageNumber }));
    }else{
        ({ data, isSuccess } = useGetVideoArticlesCategoryByPageNumberQuery({pageNumber: pageNumber}));
    }

    useEffect(() => {
        const fetchType = handleType(category);
        if (isSuccess && fetchType === 'video') {
            updateArticlesState(data);
        }
        else if (isSuccess && fetchType === 'text') {
            updateArticlesState(data);
        }
    }, [isSuccess, data, fetchType])

    useEffect(() => {
        isApiRequestInProgress = true;
        
        dispatch(addMagainzeCrumb({
            text: (typeof category === 'string' ? category:category.title),
            route: routes.magazine + '/' + (typeof category === 'string' ? category:category.title)
        }))
        return () => {
            dispatch(addMagainzeCrumb({
                text: (typeof category === 'string' ? category:category.title),
                route:  routes.magazine + '/' + (typeof category === 'string' ? category:category.title)
            }))
        }
    }, [category.title, pageNumber])

    const updateArticlesState = (data) => {
        if(!articles){
            setArticles(data.articles);
            setEndOfArticles(data.last_articles);
        } else {
            const existingArticleIds = new Set(articles.map(article => article.id));
            const newArticles = data.articles.filter(article => !existingArticleIds.has(article.id));
            setArticles(prev => [...prev, ...newArticles]);
            setEndOfArticles(data.last_articles);
        }
        isApiRequestInProgress = false;
    }

    useEffect(() => {
        if (loadMoreRef.current) {
            observer = new IntersectionObserver((entry) => {
                const thisEntry = entry[0];
                if (thisEntry.isIntersecting && !isApiRequestInProgress) {
                    setPageNumber(prev => prev + 1);
                }
            }, {});
            observer.observe(loadMoreRef.current);
        }
        return () => {
            if (observer && loadMoreRef.current) {
                observer.unobserve(loadMoreRef.current);
            }
        }
    }, [loadMoreRef.current])

    const categoryName = typeof category === 'object' ? category.title:category;
    return (
    <div className='magazine-generic-wrapper'>
        <ArticlesStrip
            articles={articles}
            title={categoryName}
            analyticsSource={AnalyticsParamValues.MAGAZINE_SECTION_PAGE_SOURCE}
        />
        {!endOfArticles && <div ref={loadMoreRef} className="load-more"></div>}
    </div>);
}

export default MagazineGeneric;
